// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20MG8","left":"styles_left__3OKY0"};